export default __webpack_public_path__ + "static/media/movie-gallery-gif.9e3575ea.gif";